module.exports = __webpack_public_path__ + "img/back-icon2.fc2cb373.png";